// TodoContext.js
import React, { createContext, useState } from "react";
import Loading from "../Student/Reusablecomponents/Loading";
const LoadContext = createContext();
const LoadProvider = ({ children }) => {

    const [Load, SetLoad] = useState(false);

    return (
        <LoadContext.Provider
            value={{
                Load, SetLoad
                // addTodo,
                // removeTodo,location.state?.Tab
            }}
        >
            {children}
            {Load && <Loading />}
        </LoadContext.Provider>
    );
};
export { LoadProvider, LoadContext };
